module["exports"] = [
  "/4###########L/",
  "/4###-####-####-###L/"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/credit_card/visa.js
// module id = 1053
// module chunks = 0